import React from 'react'
export function PrivacyPolicyPage(){
     return(
        <div className='text-left m-auto md:mt-8 w-full md:w-[580px] lg:w-[780px]'>
        <h2 className='mb-4 text-lg structure__main__subttl'>Privacy Policy</h2>
        <p className='text-sm mb-12'>
         <b>1. How we protect your information</b><br/>
         We will take your personal information seriously because to protect your information is important for us. Once you delete your account, we will remove your information from our database completely. If you care about data loss after closing your account, please save your purchased item receipts so we can apply your purchased products to your new account again.<br/><br/>

         <b>2. Community Page</b><br/>

         When you share your comment at community page, please be careful to share your personal information. To protect your information, we will remove your post comments if it is requested.<br/><br/>

         <b>3. Contact us</b><br/>

         Please contact to info@devcookboks.com if you have any question about Privacy Policy.<br/><br/>

         </p>
        </div>
     )
}